module.exports = __webpack_public_path__ + "static/media/integral_card_2.9dbac5fb.png";